/**
 * Remove inline color styles from HTML to let theme colors take priority
 * Handles various color style formats and font color tags
 */
export const removeInlineColors = (html: string): string => {
  if (!html) return "";
  
  // Remove color from style="..."
  html = html.replace(/style\s*=\s*"([^"]*)"/gi, (_match, styles) => {
    styles = styles.replace(/(?:^|;)\s*color\s*:\s*[^;]+;?/gi, ";");
    return `style="${styles}"`;
  });
  
  // Remove color from style='...'
  html = html.replace(/style\s*=\s*'([^']*)'/gi, (_match, styles) => {
    styles = styles.replace(/(?:^|;)\s*color\s*:\s*[^;]+;?/gi, ";");
    return `style="${styles}"`;
  });
  
  // Remove <font color="...">
  html = html.replace(/(<font\b[^>]*?)\s+color\s*=\s*(['"])[^'"]*\2/gi, "$1");
  
  return html;
};
